export default {
    PUSH: 'push',
    EMAIL: 'email',
    EMAIL_AND_PUSH: 'email_and_push',
};
